export const docMask = 'aa 9999999';
